
export default {
  getApps: '/api/manageApps/getApps',
  deleteRestoreApp: '/Apps/Manage.aspx/DeleteRestoreApp',
  fixAppUrl: './Service.asmx/UpdatePublisherAppUrl',
}



// WEBPACK FOOTER //
// ./src/urls/manageAppsUrls.js